// Helper function to flatten gains/costs
const flattenAttributes = obj => {
  let flatEntries = [];
  if ('traits' in obj || 'resources' in obj || 'status' in obj) {
    if (obj.traits) {
      flatEntries = flatEntries.concat(Object.entries(obj.traits).map(([attribute, change]) => [attribute, change]));
    }
    if (obj.resources) {
      flatEntries = flatEntries.concat(Object.entries(obj.resources).map(([attribute, change]) => [attribute, change]));
    }
    if (obj.status) {
      flatEntries = flatEntries.concat(Object.entries(obj.status).map(([attribute, change]) => [attribute, change]));
    }
  } else {
    flatEntries = Object.entries(obj);
  }
  return flatEntries;
};

export const format = ({ gain, cost }) => {
  let messageParts = [];
  // Process gains and costs
  let entries = gain ? flattenAttributes(gain) : [];
  entries = cost ? entries.concat(flattenAttributes(cost).map(([attribute, change]) => [attribute, -change])) : entries;

  for (const [attribute, change] of entries) {
    if (change !== 0) {
      const changePrefix = change > 0 ? '+' : '';
      messageParts.push(`**${attribute} ${changePrefix}${change}**`);
    }
  }

  return messageParts.length > 0 ? messageParts.join('. ') : '';
};

const messageFormatter = (text, effect) => {
  if (!effect) return { id: new Date(), label: text };

  let { cost, gain } = effect;
  return {
    id: new Date(),
    label: `${text} ${format({ cost, gain })}`
  };
};

const randomMessage = messages => {
  const index = Math.floor(Math.random() * messages.length);
  return messages[index];
};

export { messageFormatter, messageFormatter as formatMessage, randomMessage };
